@if (isEsko || (parentBranding$ | async)) {
  <mat-icon [ngClass]="class" [color]="invert ? 'secondary' : 'accent'">esko</mat-icon>
} @else {
  <mat-icon class="body" [ngClass]="class" [color]="invert ? 'secondary' : 'ink'">zeffi_bird_body</mat-icon>
  <mat-icon class="head" [ngClass]="class" [color]="invert ? 'secondary' : 'accent'">zeffi_bird_head</mat-icon>
}
